import React from 'react';
import { colors } from '../theme/index.js';
import Text from './Text.js';

/**
 *
 * @param {*} param0
 */
const PhotoGrid = ({
  photos,
  uploadError,
  altText,
  id,
  testid
}) => {
  const styles = {
    container: {
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20
    },
    image: {
      alignSelf: 'center',
      backgroundColor: 'transparent',
      height: 'auto',
      width: '46%',
      margin: 10
    },
    imageError: {
      alignSelf: 'center',
      backgroundColor: colors.pink,
      height: 'auto',
      width: '100%',
      padding: 10,
      borderRadius: 8
    },
    errorDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '46%',
      margin: 5
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id || testid,
    style: styles.container
  }, photos.map(photo => {
    const error = uploadError && uploadError.some(file => file.name === photo.name);
    if (error) {
      return /*#__PURE__*/React.createElement("div", {
        style: styles.errorDiv
      }, /*#__PURE__*/React.createElement("img", {
        alt: altText,
        key: photo.file,
        src: photo.image,
        style: styles.imageError
      }), /*#__PURE__*/React.createElement(Text, {
        small: true,
        bold: true,
        align: "center",
        color: colors.red
      }, "Not Uploaded!"));
    }
    return /*#__PURE__*/React.createElement("img", {
      alt: altText,
      key: photo.image,
      src: photo.image,
      style: styles.image
    });
  }));
};
export default PhotoGrid;